var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequestsActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "mvjgu2g6ta",
  d: "M0 .548h20.248V19H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .453)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "w2uxx6k4ob",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mvjgu2g6ta"
})), /*#__PURE__*/React.createElement("path", {
  d: "m16.878 4.939-6.07 6.28a.697.697 0 1 1-1-.97l6.06-6.28c.27-.28.71-.28.99-.02.28.27.29.72.02.99zm-8.064 12.09v-3.293l1.628.616-1.628 2.678zM1.148 9.604l-.174-.394.174.394zm19.095-7.907a1.134 1.134 0 0 0-.372-.838A1.187 1.187 0 0 0 18.586.65L.69 8.569A1.142 1.142 0 0 0 0 9.615c-.01.44.283.902.75 1.072l6.663 2.52v4.644a1.13 1.13 0 0 0 .392.859c.229.196.503.289.787.29a1.17 1.17 0 0 0 1.003-.561l2.15-3.536c.009-.016.01-.035.018-.052l6.888 2.605a1.189 1.189 0 0 0 1.228-.235 1.14 1.14 0 0 0 .369-.837l-.006-14.688z",
  fill: "#6467EF",
  mask: "url(#w2uxx6k4ob)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequestsActive);
export default ForwardRef;